import { type PayableSubType } from '@spendesk/bookkeeping-core-types';

import { useSupplierSyncStatus } from 'modules/suppliers/hooks';
import { useGetDefaultVendorsQuery } from 'src/core/modules/bookkeep/settings/integrations/hooks/useGetDefaultVendorsQuery';

type SyncStatus =
  | {
      synced: true;
      anchor: 'simple';
      url: string | null;
    }
  | {
      synced: false;
      anchor: 'simple';
    }
  | {
      synced: true;
      anchor: 'defaultVendor';
      defaultVendorName: string;
      url: string | null;
    }
  | {
      synced: false;
      anchor: 'defaultVendor';
    }
  | undefined;

export const useGetSupplierSyncWithDefault = (
  supplierId: string | undefined,
  payableType?: PayableSubType,
): SyncStatus => {
  const defaultVendors = useGetDefaultVendorsQuery();
  const supplierSyncStatus = useSupplierSyncStatus(supplierId);

  let defaultVendorType;
  switch (payableType) {
    case 'physical':
      defaultVendorType = 'physical' as const;
      break;

    case 'subscription':
      defaultVendorType = 'subscription' as const;
      break;

    case 'singlePurchase':
      defaultVendorType = 'singlePurchase' as const;
      break;

    case 'multiUseCard':
      defaultVendorType = 'multiUseCard' as const;
      break;

    default:
      break;
  }

  const defaultVendor =
    defaultVendorType &&
    defaultVendors.status === 'success' &&
    defaultVendors.data[defaultVendorType];

  if (defaultVendor) {
    if (defaultVendor.status === 'synced') {
      return {
        synced: true,
        anchor: 'defaultVendor',
        defaultVendorName: defaultVendor.name,
        url: defaultVendor.url,
      };
    }

    return {
      synced: false,
      anchor: 'defaultVendor',
    };
  }

  if (
    defaultVendors.status === 'success' &&
    supplierSyncStatus.status === 'success'
  ) {
    return { anchor: 'simple', ...supplierSyncStatus.data };
  }
};
